module.exports = __webpack_public_path__ + "static/media/icon_account.18940427.svg";